import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

const Index = () => {
  const { user, role, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate("/auth");
      } else if (role === "admin") {
        navigate("/orders");
      } else if (role === "installer") {
        navigate("/installations/mine");
    } else if (role) {
      navigate("/dashboard");
    } else {
      console.warn("Käyttäjällä ei ole roolia, ohjataan auth-sivulle");
      navigate("/auth");
    }
    }
  }, [user, role, loading, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
};

export default Index;
